<template>    
    <Dialog :visible="visible" modal header="Seleccione el trabajo" :style="{width: '1400px'}"  :closable="false">
        <div class="card card-default card-tabs" style="margin:0">
            <div class="card-header p-1 pt-1">
                <ul class="nav nav-pills" ref="tabHeaders">
                    <li  class="nav-item">
                        <a class="nav-link active" href="#general" data-toggle="tab">
                            General
                        </a>
                    </li>
                    <li class="nav-item" v-if="mostrarFacturacionAxa">
                        <a @click="obtenerAfectados(); console.log('trabajodatos', this.trabajodatos.idtrabajo_servicio);" class="nav-link" data-toggle="tab" href="#webservice">
                            Web service AXA
                        </a>
                    </li>
                    <li class="nav-item" v-if="mostrarElba">
                        <a @click="cargarBaremosElba()" class="nav-link" data-toggle="tab" href="#elba">
                            ELBA
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content" ref="tabContents" style=" margin-top: 15px; padding-bottom: 15px;">
            <div class="tab-pane active container-grid" id="general">
                <div v-if="isSaving" class="dialog-overlay">
                    <i class="fas fa-spinner fa-spin"></i> Guardando...
                </div>
                <div v-else-if="isLoading" class="loading-spinner">
                    <i class="fas fa-spinner fa-spin"></i> Cargando trabajos...
                </div>
                <div v-else style="display: flex; gap: 15px;">
                    <div style="width: 80%;">
                        <!-- Mostrar el spinner si los trabajos están cargando -->                        
                        <Listbox v-model="trabajoSeleccionado" :options="trabajosFiltrados" optionLabel="label" class="w-full md:w-14rem" listStyle="max-height:250px">
                            <template #option="slotProps">
                                <div v-if="this.operario" class="flex align-items-center">                        
                                    <div>{{ slotProps.option.codigo }} {{ slotProps.option.nombre }} [{{ slotProps.option.precio_operario }}€]</div>
                                </div>
                                <div v-else class="flex align-items-center">                        
                                    <div>{{ slotProps.option.codigo }} {{ slotProps.option.nombre }} [{{ slotProps.option.precio }}€]</div>
                                </div>
                            </template>
                        </Listbox>           
                    </div>
                    <div>
                        <input style="flex-grow: 1;" v-model="filtro" type="text" placeholder="Filtrar">     
                    </div>
                </div>
            </div>

            <!-- BAREMOS ELBA -->
            <div class="tab-pane container-grid" id="elba">
                <div style="display: flex; gap: 15px;">
                    <div style="width: 80%;">
                        <Listbox v-model="tarifaElbaSeleccionada" :options="tarifasElbaFiltradas" optionLabel="texto" class="w-full md:w-14rem" listStyle="max-height:250px">
                            <template #option="slotProps">
                                <div class="flex align-items-center">
                                    <div>{{ slotProps.option.valor }} {{ slotProps.option.texto }}</div>
                                </div>
                            </template>
                        </Listbox>
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 10px;">
                        <Dropdown v-model="categoriaElbaSeleccionada" :options="categoriasElba" optionLabel="texto" optionValue="valor" showClear placeholder="Categoría" />
                        <input v-model="filtroElba" type="text" placeholder="Filtrar">
                    </div>
                </div>
            </div>
            
            <!-- APARTADO DE BAREMOS DE AXA -->
            <div v-if="servicio.compania.sistema" class="tab-pane container-grid" id="webservice">
                <div v-if="isLoading" class="loading-spinner">
                    <i class="fas fa-spinner fa-spin"></i> Cargando trabajos...
                </div>
                <div v-else-if="isSaving" class="dialog-overlay">
                    <i class="fas fa-spinner fa-spin"></i> Guardando...
                </div>
                <div v-else-if="errorBaremo">
                    <div class="alert alert-danger" role="alert">                
                        <h4>{{ errorBaremo }}</h4>
                    </div>
                </div>
                <div v-else>
                    <div style="display: flex;">
                        <select class="form-control" v-model="tipoPresu" id="">
                            <option value="">Seleccione nuevo o iniciado</option>
                            <option value="nuevoPresu">Nuevo</option>
                            <option value="presuCreado">Creado</option>
                        </select>
                    </div>
                    <!-- APARTADO PARA AGREGAR PRESU/VAL DE AXA AL TRABAJO -->
                    <div v-if="tipoPresu == 'nuevoPresu'">
                        <div style="margin: 15px 0; display: grid; gap: 15px; grid-template-columns: 3fr 4fr 2fr 2fr;">                        
                            <select :disabled="!afectadosCargados" v-model="afectadoSeleccionado" class="form-control" id="">
                                <option disabled value="">Seleccione afectado</option>
                                <option v-for="afectado in afectados" :key="afectado.IdAfectado" :value="afectado">{{ afectado.NombreAfectado }}</option>
                            </select>
                            <select :disabled="!oficiosCargados" v-model="oficioSeleccionado" class="form-control" id="">
                                <option disabled value="">Seleccione oficio</option>
                                <option v-for="oficio in oficios" :disabled="oficio.TotalEspecialidad!=''" :key="oficio.IdEspecialidad+'-'+oficio.Indice" :value="oficio">{{ oficio.NombreEspecialidad }} - {{oficio.Estado}}({{ oficio.FechaEstado }}) <span v-if="oficio.TotalEspecialidad">{{ oficio.TotalEspecialidad }}€</span></option>
                            </select>
                            <select :disabled="!presupuestarCargado" v-model="presupuestarSeleccionado" class="form-control" id="">
                                <option disabled value="">Seleccione tipo</option>
                                <option v-for="presupuestar in presupuestarTipos" :key="presupuestar" :value="presupuestar">{{ presupuestar }}</option>
                            </select>
                        </div>
                        <div style="display: flex; gap: 15px;">
                            <!-- LISTADO DE PRESUS/VALS DISPONIBLES PARA EL  AFECTADO, OFICIO Y TIPO SELECCIONADOS -->
                            <div style="width: 80%;">                
                                <Listbox :modelValue="trabajoServiceSeleccionado" @update:modelValue="datosBaremo" :options="trabajosServiceFiltrados" optionLabel="label" class="w-full md:w-14rem" listStyle="max-height:250px">
                                    <template #option="slotProps">
                                        <div class="flex align-items-center">                        
                                            <div v-if="slotProps.option.extra==0">{{ slotProps.option.nombre_categoria }} - {{ slotProps.option.desc_linea }} [{{ slotProps.option.tipo_linea }}] - min: {{ slotProps.option.min_uds }} - max: {{ slotProps.option.max_uds }}</div>
                                            <div v-else>{{ slotProps.option.nombre_categoria }} - {{ slotProps.option.desc_linea }} [{{ slotProps.option.tipo_linea }}] - extra: {{ slotProps.option.extra }}</div>
                                        </div>
                                    </template>
                                </Listbox>           
                            </div>
                            <div style="display: grid; gap: 10px;">
                                <div>
                                    <input style="flex-grow: 1;" v-model="filtroService" type="text" placeholder="Filtrar">
                                </div>
                                <div style="display: flex; gap: 10px;">
                                    <div style="display: grid;">
                                        <label style="margin: 0;" for="">Unidad</label>
                                        <input class="form-control" v-model="unidad" disabled type="text">
                                    </div>
                                    <div style="display: grid;">
                                        <label style="margin: 0;" for="">Uds</label>
                                        <input @blur="calcularPrecio" class="form-control" v-model="unidades" :disabled="unidadesDisabled" type="text">
                                    </div>
                                </div>
                                <div style="display: flex; gap: 10px;">
                                    <div style="display: grid;">
                                        <label style="margin: 0;" for="">Precio</label>
                                        <input class="form-control" @blur="calcularPrecio" v-model="precio" :disabled="precioDisabled" type="number">
                                    </div>
                                    <div style="display: grid;">
                                        <label style="margin: 0; width: 85px;" for="">IVA(%)</label>
                                        <select class="form-control" v-model="ivaSeleccionado" id="">
                                            <option v-for="iva in ivas" :key="iva" :value="iva">{{ iva }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="urgenteVisible" style="display: flex; gap: 5px">
                                    <label style="margin: 0;" for="">Urgente</label>
                                    <input v-model="urgente" type="checkbox">
                                </div>
                                <div v-if="minKmFacturablesVisible" style="display: grid;">
                                    <label style="margin: 0;" for="">Mínimo</label>
                                    <input class="form-control" v-model="minKmFacturables" disabled type="text">
                                </div>
                                <div style="display: grid;">
                                    <label style="margin: 0;" for="">Descripción</label>
                                    <textarea :disabled="comentarioDisabled" v-model="comentario" rows="2" class="form-control" id=""></textarea>
                                </div>
                                <div style="display: flex; justify-content: end;">
                                    <Button :disabled="precio==''" label="Agregar" @click="agregarTrabajo()" class="btn-primary" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tipoPresu == 'presuCreado'">                
                        <select style="margin-bottom: 15px; margin-top: 15px" class="form-control" v-model="presupuestoTemporalSeleccionado">
                            <option value="">Seleccione un presupuesto temporal</option>
                            <option v-for="presupuesto in presupuestosCreados" :key="presupuesto.id_presupuesto" :value="presupuesto">Nº {{ presupuesto.id_presupuesto }}-{{ presupuesto.version }} --- {{ presupuesto.afectado }} --- Estado: {{ presupuesto.estado }}</option>
                        </select>
                        <div style="display: flex; gap: 25px; margin-bottom: 15px;">
                            <select :disabled="!oficiosTemporalesCargados" v-model="oficioTemporalSeleccionado" class="form-control" id="">
                                <option disabled value="">Seleccione oficio</option>
                                <option v-for="oficio in oficiosTemporales" :disabled="oficio.TotalEspecialidad!='' && !oficiosEnPresupuestoActual.includes(oficio.IdEspecialidad+'-'+oficio.Indice)" :key="oficio.IdEspecialidad+'-'+oficio.Indice" :value="oficio">{{ oficio.NombreEspecialidad }} - {{oficio.Estado}}({{ oficio.FechaEstado }})<span v-if="oficio.TotalEspecialidad">{{ oficio.TotalEspecialidad }}€</span><span v-if="oficiosEnPresupuestoActual.includes(oficio.IdEspecialidad+'-'+oficio.Indice)"> Actual</span></option>
                            </select>
                            <select :disabled="!presupuestarTemporalCargado" v-model="presupuestarTemporalSeleccionado" class="form-control" id="">
                                <option disabled value="">Seleccione tipo</option>
                                <option v-for="presupuestar in presupuestarTemporalTipos" :key="presupuestar" :value="presupuestar">{{ presupuestar }}</option>
                            </select>
                        </div>
                        <div style="display: flex; gap: 15px;">
                            <div style="width: 80%;">                        
                                <Listbox :modelValue="trabajoServiceTemporalSeleccionado" @update:modelValue="datosBaremoTemporal" :options="trabajosServiceTemporalesFiltrados" optionLabel="label" class="w-full md:w-14rem" listStyle="max-height:250px">
                                    <template #option="slotProps">
                                        <div class="flex align-items-center">                        
                                            <div v-if="slotProps.option.extra==0">{{ slotProps.option.nombre_categoria }} - {{ slotProps.option.desc_linea }} [{{ slotProps.option.tipo_linea }}] - min: {{ slotProps.option.min_uds }} - max: {{ slotProps.option.max_uds }}</div>
                                            <div v-else>{{ slotProps.option.nombre_categoria }} - {{ slotProps.option.desc_linea }} [{{ slotProps.option.tipo_linea }}] - extra: {{ slotProps.option.extra }}</div>
                                        </div>
                                    </template>
                                </Listbox>           
                            </div>
                            <div style="display: grid; gap: 10px;">
                                <div>
                                    <input style="flex-grow: 1;" v-model="filtroServiceTemporal" type="text" placeholder="Filtrar">
                                </div>
                                <div style="display: flex; gap: 10px;">
                                    <div style="display: grid;">
                                        <label style="margin: 0;" for="">Unidad</label>
                                        <input class="form-control" v-model="unidadTemporal" disabled type="text">
                                    </div>
                                    <div style="display: grid;">
                                        <label style="margin: 0;" for="">Uds</label>
                                        <input @blur="calcularPrecioTemporal" class="form-control" v-model="unidadesTemporal" :disabled="unidadesDisabledTemporal" type="text">
                                    </div>
                                </div>
                                <div style="display: flex; gap: 10px;">
                                    <div style="display: grid;">
                                        <label style="margin: 0;" for="">Precio</label>
                                        <input class="form-control" @blur="calcularPrecioTemporal" v-model="precioTemporal" :disabled="precioDisabledTemporal" type="number">
                                    </div>
                                    <div style="display: grid;">
                                        <label style="margin: 0; width: 85px;" for="">IVA(%)</label>
                                        <select class="form-control" v-model="ivaSeleccionadoTemporal" id="">
                                            <option v-for="iva in ivasTemporal" :key="iva" :value="iva">{{ iva }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="urgenteTemporalVisible" style="display: flex; gap: 5px">
                                    <label style="margin: 0;" for="">Urgente</label>
                                    <input v-model="urgenteTemporal" type="checkbox">
                                </div>
                                <div v-if="minKmFacturablesTemporalVisible" style="display: grid;">
                                    <label style="margin: 0;" for="">Mínimo</label>
                                    <input class="form-control" v-model="minKmFacturables" disabled type="text">
                                </div>
                                <div style="display: grid;">
                                    <label style="margin: 0;" for="">Descripción</label>
                                    <textarea :disabled="comentarioDisabledTemporal" v-model="comentarioTemporal" rows="2" class="form-control" id=""></textarea>
                                </div>
                                <div style="display: flex; justify-content: end;">
                                    <Button :disabled="precioTemporal==''" label="Agregar" @click="agregarTrabajoAPresuCreado()" class="btn-primary" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>        
        <template #footer>
            <Button label="Cancelar" @click="$emit('update:visible', false)" class="btn-default" />
        </template>        
    </Dialog>
</template>


<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import Dialog from 'primevue/dialog';
import Listbox from 'primevue/listbox';
export default {
    props: ['trabajodatos', 'visible', 'operario', 'servicio'],
    components: {
        Dialog,
        Listbox,
    },
    data() {
        return {
            errorBaremo:'',
            mostrarFacturacionAxa:false,
            presupuestarTemporalCargado:false,
            oficiosTemporalesCargados:false,
            presupuestarTemporalTipos:[],
            presupuestarTemporalSeleccionado:'',
            oficiosTemporales:[],
            oficioTemporalSeleccionado:'',
            presupuestosCreados:[],
            gruposAfectadosPresupuestosCreados: [],
            minKmFacturablesVisible:false,
            minKmFacturablesTemporalVisible:false,
            facturaKm:'S',
            minKmFacturables:0,
            incrementoImportePorUrgencia:0,
            comentarioDisabledTemporal:true,
            comentarioDisabled:true,
            presupuestoTemporalSeleccionado:'',
            especialidadesPresupuestos:[],
            especialidadesValoraciones:[],
            afectadosPresupuestos:[],
            afectadosValoraciones:[],
            procedenciaTemporalSeleccionada:'',
            tipoPresu:'',
            comentario:'',
            unidadesDisabled:true,
            precioDisabled:true,
            unidades:'',
            precio:'',
            unidad:'',
            ivaSeleccionado:0,
            ivas:[],            
            presupuestarCargado:false,
            oficios:[],
            oficioSeleccionado:'',
            afectados:[],
            afectadoSeleccionado:'',
            afectadosCargados:false,
            presupuestarSeleccionado:'',
            presupuestarTipos:[],
            filtroService:'',
            filtroServiceTemporal:'',
            filtro:'',
            trabajos:[],
            trabajoSeleccionado:'',
            isLoading: false, // Estado para controlar la carga de los trabajos
            isSaving: false,  // Estado para mostrar "loading" al guardar
            especialidadesServicio:[],
            trabajoServiceSeleccionado:'',
            trabajosService:[],
            trabajosServiceTemporales:[],
            trabajoServiceTemporalSeleccionado:'',
            admiteIVAReducido:false,
            urgenteVisible:false,
            urgente:false,
            trabajoAEnviar:'',
            trabajoAEnviarTemporal:'',
            trabajosTotalesTemporales:[],
            urgenteTemporalVisible:false,
            urgenteTemporal:false,
            unidadesTemporal:'',
            precioTemporal:'',
            unidadTemporal:'',
            ivaSeleccionadoTemporal:0,
            ivasTemporal:[],
            unidadesDisabledTemporal:true,
            precioDisabledTemporal:true,
            comentarioTemporal:'',
            trabajoReferenciaTemporal:'',
            idReparador:'',
            oficiosEnPresupuestoActual:[],
            tarifasElba: [],
            categoriasElba: [],
            categoriaElbaSeleccionada: null,
            filtroElba: '',
            tarifaElbaSeleccionada: null
        };
    },
    computed:{
        trabajosFiltrados(){
            if(this.filtro==''){
                return this.trabajos;
            }else{
                return this.trabajos.filter(t => t.codigo.toLowerCase().includes(this.filtro.toLowerCase())||t.nombre.toLowerCase().includes(this.filtro.toLowerCase()));
            }
        },
        trabajosServiceFiltrados(){
            if(this.filtroService==''){
                return this.trabajosService;
            }else{
                return this.trabajosService.filter(t => t.nombre_categoria.toLowerCase().includes(this.filtroService.toLowerCase())||t.desc_linea.toLowerCase().includes(this.filtroService.toLowerCase()));
            }
        },
        trabajosServiceTemporalesFiltrados(){
            if(this.filtroServiceTemporal==''){
                return this.trabajosServiceTemporales;
            }else{
                return this.trabajosServiceTemporales.filter(t => t.nombre_categoria.toLowerCase().includes(this.filtroService.toLowerCase())||t.desc_linea.toLowerCase().includes(this.filtroService.toLowerCase()));
            }
        },
        tarifasElbaFiltradas(){
            let resultado = this.tarifasElba;
            
            if(this.categoriaElbaSeleccionada){
                resultado = resultado.filter(t => t.parametros?.category?.code === this.categoriaElbaSeleccionada);
            }
            
            if(this.filtroElba !== ''){
                resultado = resultado.filter(t => 
                    t.valor.toLowerCase().includes(this.filtroElba.toLowerCase()) || 
                    t.texto.toLowerCase().includes(this.filtroElba.toLowerCase())
                );
            }
            
            return resultado;
        },
        mostrarElba(){
            return this.servicio?.compania.sistema === 'ELBA_WS';
        }
    },
    methods: {
        async obtenerBaremos(){
            const api = new PwgsApi();
            this.trabajosService = [];
            this.trabajosTotales = [];
            this.urgente=false;
            this.trabajosTotales = await api.post('servicios/' + this.trabajodatos.id + '/baremos',{
                id_especialidad: this.oficioSeleccionado.IdEspecialidad,
                tipo: 'Presupuestos',
                presupuestar: this.presupuestarSeleccionado
            });
            if(!this.trabajosTotales){
                this.trabajosTotales = [];
            }
            if(this.presupuestarSeleccionado=='PresupuestarPorMO'){
                const nuevoTrabajo = {};
                nuevoTrabajo.reparador = this.idReparador;
                nuevoTrabajo.id_especialidad = this.oficioSeleccionado.IdEspecialidad;
                nuevoTrabajo.tipo = this.presupuestarSeleccionado;
                nuevoTrabajo.procedencia = 'Presupuestos';
                nuevoTrabajo.id_baremo = 0;
                nuevoTrabajo.id_categoria = 0;
                nuevoTrabajo.nombre_categoria = 'material';
                nuevoTrabajo.clave_linea = 0;
                nuevoTrabajo.id_linea = 0;
                nuevoTrabajo.desc_linea = 'material';
                nuevoTrabajo.desc_unidad = 'UD';
                nuevoTrabajo.id_unidad = 0;
                nuevoTrabajo.extra = 1;
                nuevoTrabajo.min_uds = 0;
                nuevoTrabajo.max_uds = 0;
                nuevoTrabajo.precio = 0;
                nuevoTrabajo.tipo_linea = 'Materiales';
                nuevoTrabajo.visita = 'N';
                nuevoTrabajo.id_tarifa = 0;
                nuevoTrabajo.timestamp = '';
                this.trabajosTotales.unshift(nuevoTrabajo);                
            }


            //QUE HACER CON MATERIALES A MO, YA QUE NO VAN UNIDOS A UN TRABAJO REAL
            // if(this.presupuestarSeleccionado=='PresupuestarPorMO'){
            //     this.trabajosTotales.push({
            //         clave_linea: '0',
            //         desc_linea: 'material',
            //         desc_unidad:'ud',
            //         extra: 0,
            //         id_baremo:0,
            //     })
            // }
            if(this.facturaKm!='S'){
                this.trabajosTotales = this.trabajosTotales.filter(t => t.tipo_linea != 'Desplazamiento');
            }
            console.log('llegatrabs', this.trabajosTotales);
            this.trabajosTotales.forEach(trabajo => {
                if(this.trabajosService.length==0){
                    this.trabajosService.push(trabajo);
                }else{
                    var encontrado = '';
                    encontrado = this.trabajosService.find(t => t.desc_linea == trabajo.desc_linea && t.nombre_categoria == trabajo.nombre_categoria && t.tipo_linea == trabajo.tipo_linea && t.procendencia == trabajo.procedencia && t.id_especialidad == trabajo.id_especialidad);
                    if(!encontrado){
                        this.trabajosService.push(trabajo);
                    }
                }
            })
            if(this.trabajosService.length>0){
                //
            }else{
                this.trabajoServiceSeleccionado = '';
            }
        },
        async obtenerBaremosTemporal(){
            const api = new PwgsApi();
            this.trabajosServiceTemporales = [];
            this.trabajosTotalesTemporales = [];
            console.log('tempSeleccionado', this.presupuestoTemporalSeleccionado, this.oficioTemporalSeleccionado);
            this.trabajosTotalesTemporales = await api.post('servicios/' + this.trabajodatos.id + '/baremos',{
                id_especialidad: this.oficioTemporalSeleccionado.IdEspecialidad,
                tipo: 'Presupuestos',
                presupuestar: this.presupuestarTemporalSeleccionado
            });            
            if(!this.trabajosTotalesTemporales){
                this.trabajosTotalesTemporales = [];
            }
            if(this.presupuestarTemporalSeleccionado=='PresupuestarPorMO'){                
                const nuevoTrabajo = {};
                nuevoTrabajo.reparador = this.idReparador;
                nuevoTrabajo.id_especialidad = this.oficioSeleccionado.IdEspecialidad;
                nuevoTrabajo.tipo = this.presupuestarSeleccionado;
                nuevoTrabajo.procedencia = 'Presupuestos';
                nuevoTrabajo.id_baremo = 0;
                nuevoTrabajo.id_categoria = 0;
                nuevoTrabajo.nombre_categoria = 'material';
                nuevoTrabajo.clave_linea = 0;
                nuevoTrabajo.id_linea = 0;
                nuevoTrabajo.desc_linea = 'material';
                nuevoTrabajo.desc_unidad = 'UD';
                nuevoTrabajo.id_unidad = 0;
                nuevoTrabajo.extra = 1;
                nuevoTrabajo.min_uds = 0;
                nuevoTrabajo.max_uds = 0;
                nuevoTrabajo.precio = 0;
                nuevoTrabajo.tipo_linea = 'Materiales';
                nuevoTrabajo.visita = 'N';
                nuevoTrabajo.id_tarifa = 0;
                nuevoTrabajo.timestamp = '';
                console.log('nuevoTrabajo', nuevoTrabajo, this.trabajosTotales);
                this.trabajosTotalesTemporales.unshift(nuevoTrabajo);
            }
            if(this.facturaKm != 'S'){
                this.trabajosTotalesTemporales = this.trabajosTotalesTemporales.filter(t => t.tipo_linea != 'Desplazamiento');
            }
            console.log('llegatrabstot', this.trabajosTotalesTemporales);
            if(this.trabajosTotalesTemporales && this.trabajosTotalesTemporales.length>0){
                this.trabajosTotalesTemporales.forEach(trabajo => {
                    if(this.trabajosServiceTemporales.length==0){
                        this.trabajosServiceTemporales.push(trabajo);
                    }else{
                        var encontrado = '';
                        encontrado = this.trabajosServiceTemporales.find(t => t.desc_linea == trabajo.desc_linea && t.nombre_categoria == trabajo.nombre_categoria && t.tipo_linea == trabajo.tipo_linea && t.procendencia == trabajo.procedencia && t.id_especialidad == trabajo.id_especialidad);
                        if(!encontrado){
                            this.trabajosServiceTemporales.push(trabajo);
                        }
                    }
                })
            }
            if(this.trabajosServiceTemporales.length>0){
                //
            }else{
                this.trabajoServiceTemporalSeleccionado = '';
            }
        },
        async cargarCreados() {
            const api = new PwgsApi();
            console.log('11111');
            if(this.trabajodatos){
                console.log('2222');
                var datos = await api.post('servicios/' + this.trabajodatos.id + '/oficios');
                console.log('llegaaquicargarcreados', datos.RepairEstimateValuationList);
                var trabajos = await api.get('trabajos/'+ this.trabajodatos.id + '/presuval-axa');
                if(!trabajos) trabajos = [];
                var creados = trabajos.filter(trabajo => trabajo.Enviado == 'S');
                if(datos.RepairEstimateValuationList){
                    console.log('entradatosencargo', datos);
                    this.afectadosPresupuestos = datos.RepairEstimateValuationList.Presupuestos.OficiosAfectado[0].Afectado;
                    this.afectadosValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado;
                    this.especialidadesPresupuestos = datos.RepairEstimateValuationList.Presupuestos.OficiosAfectado[0].Afectado[0].Especialidades;
                    this.especialidadesValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado[0].Especialidades;
                    this.cargarPresupuestosCreados(creados);
                }
                if(datos.DatosReparador){
                    this.facturaKm = datos.DatosReparador.FacturaKm;
                    this.minKmFacturables = datos.DatosReparador.MinKmFacturables;
                    this.idReparador = datos.DatosReparador.IdReparador;
                    console.log('entradatosrepara', this.minKmFacturables, datos.DatosReparador.MinKmFacturables);
                    this.incrementoImportePorUrgencia = datos.DatosReparador.IncrementoImportePorUrgencia;
                }
            }
        },

        //no se usa
        async cargarTemporales(creados) {
            const api = new PwgsApi();
            var temporales = await api.get('trabajos/'+ this.trabajodatos.id + '/presuval-axa');
            console.log('temporalesss', temporales);
            console.log('especialidadesPresupuestos', this.especialidadesPresupuestos);
            if(temporales && temporales.length>0){
                temporales.forEach(tempo => {
                    if(tempo.TipoPrepVal == 'P'){
                        if(this.presupuestosTemporales.length == 0){
                            var especialidadEncontrada = this.especialidadesPresupuestos.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad);
                            var grupoPresupuestoTemporal = {
                                especialidad: especialidadEncontrada.NombreEspecialidad,
                                idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                indice : tempo.Indice,
                                trabajos: [],
                                materiales: [],
                            };
                            if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                grupoPresupuestoTemporal.trabajos.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Material'){
                                grupoPresupuestoTemporal.materiales.push(tempo);
                            }
                            console.log('grupoPresupuestoTemporal', grupoPresupuestoTemporal);
                            this.presupuestosTemporales.push(grupoPresupuestoTemporal);
                            console.log('presupuestosTemporales', this.presupuestosTemporales);
                        }else{
                            var grupoEncontrado = this.presupuestosTemporales.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                            if(grupoEncontrado){
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEncontrado.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Material'){
                                    grupoPresupuestoTemporal.materiales.push(tempo);
                                }
                            }else{
                                var especialidadEncontrada2 = this.especialidadesPresupuestos.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad);
                                var grupoPresupuestoTemporal2 = {
                                    especialidad: especialidadEncontrada2.NombreEspecialidad,
                                    idEspecialidad: especialidadEncontrada2.IdEspecialidad,
                                    indice : tempo.Indice,
                                    trabajos: [],
                                    materiales: [],
                                };
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoPresupuestoTemporal2.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Material'){
                                    grupoPresupuestoTemporal2.materiales.push(tempo);
                                }
                                this.presupuestosTemporales.push(grupoPresupuestoTemporal2);
                                console.log(creados);
                            }
                        }
                    }
                    
                });
            }
            console.log('presupuestosTemporales', this.presupuestosTemporales);
        },
        redondear(value) {
            return Number.isInteger(value)
                ? value
                : parseFloat(value.toFixed(2));
        },
        async cargarPresupuestosCreados(creados){
            this.cargandoCreados = true;
            try{
                const api = new PwgsApi();
                this.gruposAfectadosPresupuestosCreados = [];
                console.log('temporales2', creados);
                //recorremos los trabajos obtenidos (los conectados con axa, es decir que tienen parametros de env�o)
                if(creados && creados.length>0){
                    var datosPresupuestos = await api.post('servicios/' + this.trabajodatos.id + '/obtenerPresuval',  {tipo:'P'});
                }            
                creados.forEach(tempo => {      
                    var presupuestosAxa = datosPresupuestos.RepairEstimateValuationList.Presupuestos.ListadoPresupuestos[0].Presupuesto;          
                    //buscamos su afectado y especialidad
                    var afectadoEncontrado = this.afectadosPresupuestos.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                    var especialidadEncontrada = afectadoEncontrado.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                    console.log('tempo', tempo);
                    tempo.TotalConIva = this.redondear(parseFloat(tempo.TotalConIva));
                    tempo.TotalSinIva = this.redondear(parseFloat(tempo.TotalSinIva));
                    //cogemos solo los presupuestos
                    if(tempo.TipoPrepVal == 'P'){                  
                        var grupoAfectadoEncontrado = undefined;
                        
                        //AGRUPAMOS LOS TRABAJOS POR AFECTADO
    
                        //si no hay ningun grupo de afectados, creamos uno
                        if(this.gruposAfectadosPresupuestosCreados.length == 0){
                            var grupoAfectadoTemporal = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                presupuestosCreados: [],
                            }
                            this.gruposAfectadosPresupuestosCreados.push(grupoAfectadoTemporal);
                            grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosCreados[0];
                            console.log('llegacrea');
                        }else{
                            //si hay alguno ya creado, buscamos el que corresponda
                            grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosCreados.find(afectado => afectado.idAfectado == tempo.IdAfectado);
                            console.log('llegaencuentra', this.gruposAfectadosPresupuestosCreados, grupoAfectadoEncontrado);
                        }
                        // si no hay un grupo de su afectado, lo creamos
                        if(grupoAfectadoEncontrado == undefined){
                            var grupoAfectadoTemporal2 = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                presupuestosCreados: [],
                            }
                            this.gruposAfectadosPresupuestosCreados.push(grupoAfectadoTemporal2);
                            grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosCreados[this.gruposAfectadosPresupuestosCreados.length-1];
                        }
                        
                        //ya tenemos el grupo de afectado al que pertenece, ahora agrupamos de este grupo por su presupuesto
    
                        //si el grupo de afectado al que pertenece no tiene ningun presupuesto, creamos uno
                        var grupoPresupuestoEncontrado = undefined;
                        var presupuestoAxaEncontrado = presupuestosAxa.find(presupuesto => presupuesto.IdPPTOVAL == tempo.id_presuval && presupuesto.Version == tempo.version);                     
                        if(grupoAfectadoEncontrado.presupuestosCreados.length == 0){   
                            var grupoPresupuestoCreado = {
                                id_presupuesto: tempo.id_presuval,
                                version: tempo.version,
                                estado: presupuestoAxaEncontrado.Estado,
                                id_estado: presupuestoAxaEncontrado.IdEstado,
                                total: presupuestoAxaEncontrado.TotalPPTO,
                                especialidades:[],
                            }
                            grupoAfectadoEncontrado.presupuestosCreados.push(grupoPresupuestoCreado);
                            grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados[0];
                        //si el grupo de afectado al que pertenece tiene al menos un presupuesto buscamos el suyo
                        }else{
                            console.log('llegaelse', grupoAfectadoEncontrado, especialidadEncontrada);
                            grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados.find(grupo => grupo.id_presupuesto == tempo.id_presuval && grupo.version == tempo.version);
                        }
    
                        //si no hay un grupo de presupuesto al que pertenece, lo creamos
                        if(grupoPresupuestoEncontrado == undefined){                        
                            var grupoPresupuestoCreado2 = {
                                id_presupuesto: tempo.id_presuval,
                                version: tempo.version,
                                estado: presupuestoAxaEncontrado.Estado,
                                id_estado: presupuestoAxaEncontrado.IdEstado,
                                total: presupuestoAxaEncontrado.TotalPPTO,
                                especialidades:[],
                            }
                            grupoAfectadoEncontrado.presupuestosCreados.push(grupoPresupuestoCreado2);
                            grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados[grupoAfectadoEncontrado.presupuestosCreados.length-1];
                        }
    
                        //ya tenemos el grupo de presupuesto al que pertenece, ahora agrupamos de este grupo por su especialidad
    
                        //si el grupo de presupuesto al que pertenece no tiene ningun grupo de especialidad, creamos uno
                        var especialidadesAxa = presupuestoAxaEncontrado.Oficios;
                        console.log('especialidades', especialidadesAxa, especialidadEncontrada);
                        var especialidadAxaEncontrada = especialidadesAxa.find(especialidad => especialidad.IdEspecialidad == especialidadEncontrada.IdEspecialidad && especialidad.IndiceEspecialidad == especialidadEncontrada.Indice);
                        console.log('especialidadAxaEncontrada', especialidadAxaEncontrada);
                        if(grupoPresupuestoEncontrado.especialidades.length == 0){                          
                            var grupoEspecialidadCreada= {
                                especialidad: especialidadEncontrada.NombreEspecialidad,
                                idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                indice:especialidadEncontrada.Indice,
                                totalBaremo:0,
                                totalMateriales:0,
                                totalDesplazamiento:0,
                                totalIva:0,
                                total:0,
                                trabajos: [],
                                materiales: [],
                                desplazamiento:[],
                                comentario: especialidadAxaEncontrada.Comentario,
                                idProfesion: especialidadAxaEncontrada.IdProfesion,
                            };
                            if(tempo.PresupuestarPor == "BA"){
                                grupoEspecialidadCreada.presupuestarPor = "baremo";
                            }else{
                                grupoEspecialidadCreada.presupuestarPor = "M.O.";
                            }
                            if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                grupoEspecialidadCreada.totalBaremo = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.trabajos.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                grupoEspecialidadCreada.totalMateriales = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.materiales.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Desplazamiento'){
                                grupoEspecialidadCreada.totalDesplazamiento = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.desplazamiento.push(tempo);
                            }
                           
                            grupoPresupuestoEncontrado.especialidades.push(grupoEspecialidadCreada);
                        //Si el grupo de presupuesto al que pertenece ya tiene algun grupo de epecialidad, miramos si hay un grupo para la especialidad en concreto
                        }else{
                            var grupoEncontrado = grupoPresupuestoEncontrado.especialidades.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                            //si existe el grupo de especialidad del trabajo lo a�adimos aqu�
                            if(grupoEncontrado){
                                console.log('grupoEncontrado', grupoEncontrado);
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEncontrado.totalBaremo = grupoEncontrado.totalBaremo+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEncontrado.totalMateriales = grupoEncontrado.totalMateriales+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoEncontrado.totalDesplazamiento = grupoEncontrado.totalDesplazamiento+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.desplazamiento.push(tempo);
                                }
                            //si no existe el grupo de especialidad del trabajo lo creamos
                            }else{                            
                                var grupoEspecialidadCreada2= {
                                    especialidad: especialidadEncontrada.NombreEspecialidad,
                                    idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                    indice:especialidadEncontrada.Indice,
                                    totalBaremo:0,
                                    totalMateriales:0,
                                    totalDesplazamiento:0,
                                    totalIva:0,
                                    total:0,
                                    trabajos: [],
                                    materiales: [],
                                    desplazamiento:[],
                                    comentario: especialidadAxaEncontrada.Comentario,
                                    idProfesion: especialidadAxaEncontrada.IdProfesion,
                                };
                                if(tempo.PresupuestarPor == "BA"){
                                    grupoEspecialidadCreada2.presupuestarPor = "baremo";
                                }else{
                                    grupoEspecialidadCreada2.presupuestarPor = "M.O.";
                                }
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEspecialidadCreada2.totalBaremo = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEspecialidadCreada2.totalMateriales = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoEspecialidadCreada2.totalDesplazamiento = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.desplazamiento.push(tempo);
                                }
                                grupoPresupuestoEncontrado.especialidades.push(grupoEspecialidadCreada2);
                            }
                        }
                    }
                    
                });
                this.gruposAfectadosPresupuestosCreados.forEach(grupo => {
                    grupo.presupuestosCreados.forEach(presupuesto => {
                        presupuesto.especialidades.forEach(especialidad => {
                            especialidad.total = parseFloat(especialidad.total).toFixed(2);
                            especialidad.totalIva = parseFloat(especialidad.totalIva).toFixed(2);
                            
                        })
                    })
                })
                this.presupuestosCreados = [];
                console.log('gruposAfectadis1', this.gruposAfectadosPresupuestosCreados);
                this.gruposAfectadosPresupuestosCreados.forEach(grupo => {
                    grupo.presupuestosCreados.forEach(presupuesto => {
                        var presutemporal = presupuesto;
                        presutemporal.afectado = grupo.afectado;
                        presutemporal.idAfectado = grupo.idAfectado;
                        this.presupuestosCreados.push(presutemporal);
                    })
                })
                console.log('gruposAfectadis2', this.presupuestosCreados);
            }catch(e){
                console.error(e);
            }
            this.cargandoCreados = false;
        },

        async agregarTrabajo(){
            this.isSaving = true;
            if(this.trabajoAEnviar.tipo_linea=="Materiales" && this.comentario == ''){
                alert('Debe indicar una descripción');
                this.isSaving = false;
                return;
            }
            const api = new PwgsApi();
            var temporales = await api.get('trabajos/'+ this.trabajodatos.id + '/presuval-axa');
            console.log('llegaagre');
            console.log('temporales', temporales);
            console.log('trabajoAEnviar', this.trabajoAEnviar);
            var tipoEnviar = this.trabajoAEnviar.tipo;
            console.log('especialidadEnviar', this.oficioSeleccionado, this.presupuestarSeleccionado);
            var error = '';
            for(let temporal of temporales){
                if(this.trabajoAEnviar.clave_linea!=0 && temporal.trabajo.clave_linea == this.trabajoAEnviar.clave_linea && temporal.IdEspecialidad == this.oficioSeleccionado.IdEspecialidad && temporal.Indice == this.oficioSeleccionado.Indice && temporal.IdAfectado == this.afectadoSeleccionado.IdAfectado){
                    error = 'Baremo ya añadido a un trabajo.';
                    break;
                }
                //
                //
                //
                //
                //PROBAR -
                //        |
                //        V
                //
                //
                //
                if(temporal.IdEspecialidad == this.oficioSeleccionado.IdEspecialidad && temporal.Indice == this.oficioSeleccionado.Indice && temporal.IdAfectado == this.afectadoSeleccionado.IdAfectado && temporal.trabajo.tipo != tipoEnviar){
                    error = 'Ya se está creando un presupuesto para este afectado, con esa especialidad, de distinto tipo.'
                    break;
                }                
            }
            if(error != ''){
                alert(error);
                this.isSaving = false;
                return;
            }
            setTimeout(async() => {
                var total = 0;
                var precio = 0;
                var urgente = 'N';
                if(this.trabajoAEnviar.tipo_linea=="Materiales"){
                    console.log('trabajoAEnviar', this.trabajoAEnviar);
                    this.trabajoAEnviar.precioUnidad = this.precio;
                    precio = this.precio*this.unidades;
                    total = precio+(this.ivaSeleccionado*precio)/100;
                }else if(this.trabajoAEnviar.tipo_linea=="Desplazamiento"){
                    this.trabajoAEnviar.minKmFacturables = this.minKmFacturables;
                    this.trabajoAEnviar.unidadesAFacturar = this.unidades - this.minKmFacturables;
                    precio = this.precio;
                    total = parseFloat(this.precio)+parseFloat(((this.ivaSeleccionado*this.precio)/100));
                    total = parseFloat(total).toFixed(2);                    
                }else{
                    if(this.presupuestarSeleccionado == 'PresupuestarPorMO'){
                        urgente  = this.urgente?"S":"N"
                    }else{
                        urgente  = "N"
                    }
                    if(this.urgente){
                        this.precio += (this.precio * this.incrementoImportePorUrgencia)/100;
                    }
                    precio = this.precio;
                    total = this.precio+(this.ivaSeleccionado*this.precio)/100;
                }
                if(this.oficioSeleccionado.TotalEspecialidad!=''){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El oficio ya se encuentra presupuestado', life: 2000 });
                }else{
                        try{
                            console.log('trabajoAEnviar', this.trabajoAEnviar);
                            var ivaReducido = 'N';
                            if(this.admiteIVAReducido && this.ivaSeleccionado != 21 && this.ivaSeleccionado != 0){
                                ivaReducido = 'S';
                            }
                            var body = {
                                "TipoOperacion"     : "MANAGE_PREVAL",
                                "Enviado"           : "N",
                                "Facturado"         : "N",
                                "TipoPrepVal"       : 'P',
                                "IdAfectado"        : this.afectadoSeleccionado.IdAfectado,
                                "PresupuestarPor"   : this.presupuestarSeleccionado == 'PresupuestarPorMO'?'MO':'BA',
                                "IdEspecialidad"    : this.oficioSeleccionado.IdEspecialidad,
                                "Indice"            : this.oficioSeleccionado.Indice,
                                "IvaSeleccionado"   : this.ivaSeleccionado,
                                "Descripcion"       : this.comentario,
                                "IvaReducido"       : ivaReducido,                        
                                "IVAOfic"           : this.ivas[0],
                                "trabajo"           : this.trabajoAEnviar,
                                "Cantidad"          : this.unidades,
                                "Urgente"           : urgente,
                                "TotalSinIva"       : precio,
                                "TotalConIva"       : total,
                            }
                            console.log(body);
                            //await api.post('servicios/' + this.trabajodatos.id + '/crear-presupuesto', body);                        
                            await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', { baremos_trabajos_axa: 1 
                                ,iva: this.ivaSeleccionado,codigo: this.trabajoAEnviar.clave_linea, nombre: this.trabajoAEnviar.desc_linea, datos: body});
                            this.$emit('update:visible', false)
                            console.log('trabajodatosasas', this.trabajodatos, this.operario);
                            if(this.trabajodatos.destinatario_trabajo == "" || this.trabajodatos.destinatario_trabajo == "Compañia"){
                                console.log('trabajodatosasas1');
                                this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'cliente');
                            }else{
                                console.log('trabajodatosasas2', this.trabajodatos.destinatario_trabajo);
                                this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'opera');
                            }
                            this.isSaving = false;
                            this.$toast.add({severity:'success', summary: 'Agregado', detail: 'Trabajo Agregado', life: 2000});
                        }catch(e){
                            this.isSaving = false;
                            this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                        }
                }
            },1000)
        },
        async agregarTrabajoAPresuCreado(){
            this.isSaving = true;
            if(this.trabajoAEnviarTemporal.tipo_linea=="Materiales" && this.comentarioTemporal == ''){
                alert('Debe indicar una descripción');
                this.isSaving = false;
                return;
            }
            const api = new PwgsApi();
            var idsTrabajos = [];            
            var oficios = [];
            var totalPres = 0;
            for(let especialidad of this.presupuestoTemporalSeleccionado.especialidades){                
                var oficio ={
                    PresupuestarPor: especialidad.presupuestarPor,
                    IdEspecialidad: especialidad.idEspecialidad,
                    Indice: especialidad.indice,
                    Comentario: especialidad.comentario,
                    IdProfesion: especialidad.idProfesion,
                    IvaReducido:'',
                    IVAOfic:'',
                    Trabajos:[],
                    Materiales:[],
                }
                if(especialidad.trabajos && especialidad.trabajos.length > 0){
                    for(let trabajo of especialidad.trabajos){
                        idsTrabajos.push(trabajo.id_trabajo);
                        if(trabajo.PresupuestarPor == 'BA'){
                            oficio.PresupuestarPor = 'BA';
                        }else{
                            oficio.PresupuestarPor = 'MO';
                        }
                        if(trabajo.IvaReducido == 'N'){
                            oficio.IvaReducido = 'N';
                        }else{
                            oficio.IvaReducido = 'S';
                        }
                        oficio.IVAOfic = trabajo.IvaSeleccionado;                        
                        var precio2 = trabajo.trabajo.precio;
                        var trabajoOficio = {
                            IdTarifa:trabajo.trabajo.id_tarifa,
                            IdTraOfic:trabajo.trabajo.id_categoria,
                            IdLinea:trabajo.trabajo.id_linea,
                            ClaveLinea:trabajo.trabajo.clave_linea,
                            Cantidad:trabajo.Cantidad.toString().replaceAll('.',','),
                            Precio:precio2.toString().replaceAll('.',','),
                            IVABarMO:trabajo.IvaSeleccionado,
                            Urgente:trabajo.Urgente,
                            TotalConIVABarMO:trabajo.TotalConIva.toString().replaceAll('.',','),
                        }
                        totalPres += trabajo.TotalConIva;
                        oficio.Trabajos.push(trabajoOficio);
                    }
                }
                if(especialidad.materiales && especialidad.materiales.length > 0){                        
                    for(let material of especialidad.materiales){
                        idsTrabajos.push(material.trabajo.id_trabajo);
                        var precio = 0;
                        if(material.PresupuestarPor == 'BA'){
                            precio = material.trabajo.precioUnidad;
                            oficio.PresupuestarPor = 'BA';
                        }else{
                            precio = material.trabajo.precioUnidad;
                            oficio.PresupuestarPor = 'MO';
                        }
                        if(material.IvaReducido == 'N'){
                            oficio.IvaReducido = 'N';
                        }else{
                            oficio.IvaReducido = 'S';
                        }
                        oficio.IVAOfic = material.IvaSeleccionado;  
                        var materialOficio = {
                            IdTarifa:material.trabajo.id_tarifa,
                            IdTraOfic:material.trabajo.id_categoria,
                            IdLinea:material.trabajo.id_linea,
                            ClaveLinea:material.trabajo.clave_linea,
                            Cantidad:material.Cantidad.toString().replaceAll('.',','),
                            Precio:precio.toString().replaceAll(".", ","),
                            IVAMat:material.IvaSeleccionado,
                            Descripcion:material.Descripcion,
                            TotalConIVAMat:material.TotalConIva.toString().replaceAll('.',','),
                        }
                        totalPres += material.TotalConIva;
                        oficio.Materiales.push(materialOficio);
                    }
                }
                if(especialidad.desplazamiento && especialidad.desplazamiento.length > 0){                        
                    if(especialidad.desplazamiento.length > 0){
                        var desplazamiento = especialidad.desplazamiento[0];
                        
                        oficio.Desplazamiento = {
                            IdTarifa:desplazamiento.trabajo.id_tarifa,
                            IdTraOfic:desplazamiento.trabajo.id_categoria,
                            IdLinea:desplazamiento.trabajo.id_linea,
                            ClaveLinea:desplazamiento.trabajo.clave_linea,
                            Kms:desplazamiento.Cantidad,
                            KmsPrecio:desplazamiento.trabajo.precio.toString().replaceAll(".", ","),
                            IVAKms:desplazamiento.IvaSeleccionado,
                            TotalConIVAKms:desplazamiento.TotalConIva.toString().replaceAll('.',',')
                        }
                        totalPres += desplazamiento.TotalConIva;
                        console.log(totalPres);
                    }
                }
                oficios.push(oficio);                
            }

            console.log('oficios', oficios);
            var existeOficio = false;
            var error = '';
            console.log('trabajoTempo', this.trabajoAEnviarTemporal, this.oficioTemporalSeleccionado, this.presupuestoTemporalSeleccionado);
            // return;
            var total = 0;
            precio = 0;
            var urgente = 'N';
            oficios.forEach(oficio => {
                if(!error){
                    if(oficio.IdEspecialidad == this.oficioTemporalSeleccionado.IdEspecialidad && oficio.Indice == this.oficioTemporalSeleccionado.Indice){
                        existeOficio = true;
                        if(this.trabajoAEnviarTemporal.tipo == "PresupuestarPorBaremo"){
                            if(oficio.PresupuestarPor != 'BA'){
                                error = 'El oficio seleccionado está en tipo presupuestar por MO';                            
                            }
                        }else{
                            if(oficio.PresupuestarPor != 'MO'){
                                error = 'El oficio seleccionado está en tipo presupuestar por BA';
                            }
                        }
                        
                        if(!error){
                            if(this.trabajoAEnviarTemporal.tipo_linea == "Materiales"){
                                this.trabajoAEnviarTemporal.precioUnidad = this.precioTemporal;
                                precio = this.precioTemporal*this.unidadesTemporal;
                                total = precio+((this.ivaSeleccionadoTemporal*precio)/100);
                                total = total.toFixed(2);
                                var materialOficio ={
                                    IdTarifa:this.trabajoAEnviarTemporal.id_tarifa,
                                    IdTraOfic:this.trabajoAEnviarTemporal.id_categoria,
                                    IdLinea:this.trabajoAEnviarTemporal.id_linea,
                                    ClaveLinea:this.trabajoAEnviarTemporal.clave_linea,
                                    Cantidad:this.unidadesTemporal.toString().replaceAll('.',','),
                                    Precio:this.trabajoAEnviarTemporal.precioUnidad.toString().replaceAll(".", ","),
                                    IVAMat:this.ivaSeleccionadoTemporal,
                                    Descripcion:this.comentarioTemporal,
                                    TotalConIVAMat:total.toString().replaceAll('.',','),
                                }
                                oficio.Materiales.push(materialOficio);
                            }else if(this.trabajoAEnviarTemporal.tipo_linea == "Desplazamiento"){
                                if(oficios.Desplazamiento){
                                    error = 'El oficio seleccionado ya tiene desplazamiento';
                                }else{
                                    this.trabajoAEnviarTemporal.minKmFacturables = this.minKmFacturables;
                                    this.trabajoAEnviarTemporal.unidadesAFacturar = this.unidadesTemporal - this.minKmFacturables;
                                    precio = this.precioTemporal;
                                    total = parseFloat(precio)+parseFloat(((this.ivaSeleccionadoTemporal*precio)/100));
                                    total = parseFloat(total).toFixed(2); 
                                    oficio.Desplazamiento = {
                                        IdTarifa:this.trabajoAEnviarTemporal.id_tarifa,
                                        IdTraOfic:this.trabajoAEnviarTemporal.id_categoria,
                                        IdLinea:this.trabajoAEnviarTemporal.id_linea,
                                        ClaveLinea:this.trabajoAEnviarTemporal.clave_linea,
                                        Kms:this.unidadesTemporal,
                                        KmsPrecio:this.trabajoAEnviarTemporal.precio.toString().replaceAll(".", ","),
                                        IVAKms:this.ivaSeleccionadoTemporal,
                                        TotalConIVAKms:total.toString().replaceAll(".", ","),
                                    }
                                }
                            }else{
                                if(this.presupuestarTemporalSeleccionado == 'PresupuestarPorMO'){
                                    urgente  = this.urgenteTemporal?"S":"N"
                                }else{
                                    urgente  = "N"
                                }
                                console.log('llega1', this.precioTemporal, typeof this.precioTemporal);
                                if(this.urgenteTemporal){
                                    console.log('entra');
                                    this.precioTemporal += (this.precioTemporal * this.incrementoImportePorUrgencia)/100;
                                }
                                console.log('llega2', this.precioTemporal);
                                precio = this.precioTemporal;
                                total = this.precioTemporal+(this.ivaSeleccionadoTemporal*this.precioTemporal)/100;
                                total = Number(total.toFixed(2));
                                console.log('llega3', precio, total);
                                var precio2 = this.trabajoAEnviarTemporal.precio;
                                var trabajoOficio = {
                                    IdTarifa:this.trabajoAEnviarTemporal.id_tarifa,
                                    IdTraOfic:this.trabajoAEnviarTemporal.id_categoria,
                                    IdLinea:this.trabajoAEnviarTemporal.id_linea,
                                    ClaveLinea:this.trabajoAEnviarTemporal.clave_linea,
                                    Cantidad:this.unidadesTemporal.toString().replaceAll('.',','),
                                    Precio:precio2.toString().replaceAll('.',','),
                                    IVABarMO:this.ivaSeleccionadoTemporal,
                                    Urgente:urgente,
                                    TotalConIVABarMO:total.toString().replaceAll('.',','),
                                }
                                oficio.Trabajos.push(trabajoOficio);
                            }
                        }
                    }
                }
            })
            
            if(error){
                alert(error);
                this.isSaving = false;
                return;
            }

            if(!existeOficio){
                var oficio2 ={
                    PresupuestarPor: '',
                    IdEspecialidad: this.oficioTemporalSeleccionado.IdEspecialidad,
                    Indice: this.oficioTemporalSeleccionado.Indice,
                    Comentario: 'C',
                    IvaReducido:this.admiteIVAReducidoTemporal?'S':'N',
                    IVAOfic:this.ivasTemporal[0],
                    Trabajos:[],
                    Materiales:[],
                }
                if(this.presupuestarTemporalSeleccionado == 'PresupuestarPorMO'){
                    oficio2.PresupuestarPor = 'MO';
                }else{
                    oficio2.PresupuestarPor = 'BA';
                }
                if(this.trabajoAEnviarTemporal.tipo_linea == "Materiales"){
                    this.trabajoAEnviarTemporal.precioUnidad = this.precioTemporal;
                    precio = this.precioTemporal*this.unidadesTemporal;
                    total = precio+((this.ivaSeleccionadoTemporal*precio)/100);
                    total = parseFloat(total).toFixed(2);
                    var materialOficio2 ={
                        IdTarifa:this.trabajoAEnviarTemporal.id_tarifa,
                        IdTraOfic:this.trabajoAEnviarTemporal.id_categoria,
                        IdLinea:this.trabajoAEnviarTemporal.id_linea,
                        ClaveLinea:this.trabajoAEnviarTemporal.clave_linea,
                        Cantidad:this.unidadesTemporal.toString().replaceAll('.',','),
                        Precio:this.trabajoAEnviarTemporal.precioUnidad.toString().replaceAll(".", ","),
                        IVAMat:this.ivaSeleccionadoTemporal,
                        Descripcion:this.comentarioTemporal,
                        TotalConIVAMat:total.toString().replaceAll('.',','),
                    }
                    oficio2.Materiales.push(materialOficio2);                    
                }else if(this.trabajoAEnviarTemporal.tipo_linea == "Desplazamiento"){
                    this.trabajoAEnviarTemporal.minKmFacturables = this.minKmFacturables;
                    this.trabajoAEnviarTemporal.unidadesAFacturar = this.unidadesTemporal - this.minKmFacturables;
                    precio = this.precioTemporal;
                    total = parseFloat(precio)+parseFloat(((this.ivaSeleccionadoTemporal*precio)/100));
                    total = parseFloat(total).toFixed(2); 
                    oficio2.Desplazamiento = {
                        IdTarifa:this.trabajoAEnviarTemporal.id_tarifa,
                        IdTraOfic:this.trabajoAEnviarTemporal.id_categoria,
                        IdLinea:this.trabajoAEnviarTemporal.id_linea,
                        ClaveLinea:this.trabajoAEnviarTemporal.clave_linea,
                        Kms:this.unidadesTemporal,
                        KmsPrecio:this.trabajoAEnviarTemporal.precio.toString().replaceAll(".", ","),
                        IVAKms:this.ivaSeleccionadoTemporal,
                        TotalConIVAKms:total.toString().replaceAll(".", ","),
                    }
                }else{
                    if(this.presupuestarTemporalSeleccionado == 'PresupuestarPorMO'){
                        urgente  = this.urgenteTemporal?"S":"N"
                    }else{
                        urgente  = "N"
                    }
                    console.log('llega1', this.precioTemporal, typeof this.precioTemporal);
                    if(this.urgenteTemporal){
                        console.log('entra');
                        this.precioTemporal += (this.precioTemporal * this.incrementoImportePorUrgencia)/100;
                    }
                    console.log('llega2', this.precioTemporal);
                    precio = this.precioTemporal;
                    total = this.precioTemporal+(this.ivaSeleccionadoTemporal*this.precioTemporal)/100;
                    total = Number(total.toFixed(2));
                    console.log('llega3', precio, total);
                    var precio3 = this.trabajoAEnviarTemporal.precio;
                    var trabajoOficio2 = {
                        IdTarifa:this.trabajoAEnviarTemporal.id_tarifa,
                        IdTraOfic:this.trabajoAEnviarTemporal.id_categoria,
                        IdLinea:this.trabajoAEnviarTemporal.id_linea,
                        ClaveLinea:this.trabajoAEnviarTemporal.clave_linea,
                        Cantidad:this.unidadesTemporal.toString().replaceAll('.',','),
                        Precio:precio3.toString().replaceAll('.',','),
                        IVABarMO:this.ivaSeleccionadoTemporal,
                        Urgente:urgente,
                        TotalConIVABarMO:total.toString().replaceAll('.',','),
                    }
                    oficio2.Trabajos.push(trabajoOficio2);
                }
                oficios.push(oficio2);
            }

            var envio = {
                TipoOperacion:"MANAGE_PREVAL",
                TipoPrepVal:"P",
                IdEncargo:"",
                IdAfectado:this.presupuestoTemporalSeleccionado.idAfectado,
                Oficios:oficios,
                IdPrepVal:this.presupuestoTemporalSeleccionado.id_presupuesto,
                Version:this.presupuestoTemporalSeleccionado.version,
            }
            console.log('envio', envio);
            try{
                var resp = await api.post('servicios/'+ this.trabajodatos.id + '/envio-presuval', {envio:envio}); 
                console.log('respobtenida', resp);
                var presupuesto = resp['RepairEstimateValuationList']['Presupuestos']['ListadoPresupuestos'][0]['Presupuesto'][0];
                console.log('presupuestoobtenido', presupuesto);
                this.$toast.add({severity:'success', summary: 'Creado', detail: 'Presupuesto modificado', life: 2000});

                var body = {
                    "TipoOperacion"     : "MANAGE_PREVAL",
                    "Enviado"           : "S",
                    "Facturado"         : "N",
                    "TipoPrepVal"       : 'P',
                    "id_presuval"       : presupuesto['IdPPTOVAL'],
                    "version"           : presupuesto['Version'],
                    "IdAfectado"        : this.presupuestoTemporalSeleccionado.idAfectado,
                    "PresupuestarPor"   : this.presupuestarTemporalSeleccionado == 'PresupuestarPorMO'?'MO':'BA',
                    "IdEspecialidad"    : this.oficioTemporalSeleccionado.IdEspecialidad,
                    "Indice"            : this.oficioTemporalSeleccionado.Indice,
                    "IvaSeleccionado"   : this.ivaSeleccionadoTemporal,
                    "Descripcion"       : this.comentarioTemporal,
                    "IvaReducido"       : this.admiteIVAReducidoTemporal?'S':'N',                        
                    "IVAOfic"           : this.ivasTemporal[0],
                    "trabajo"           : this.trabajoAEnviarTemporal,
                    "Cantidad"          : this.unidadesTemporal,
                    "Urgente"           : urgente,
                    "TotalSinIva"       : precio,
                    "TotalConIva"       : total,
                }

                await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', { baremos_trabajos_axa: 1 
                    ,iva: this.ivaSeleccionadoTemporal,codigo: this.trabajoAEnviarTemporal.clave_linea, nombre: this.trabajoAEnviarTemporal.desc_linea, datos: body});
                this.$emit('update:visible', false)
                console.log('trabajodatosasas', this.trabajodatos, this.operario);
                if(this.trabajodatos.destinatario_trabajo == "" || this.trabajodatos.destinatario_trabajo == "Compañia"){
                    console.log('trabajodatosasas1');
                    this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'cliente');
                }else{
                    console.log('trabajodatosasas2', this.trabajodatos.destinatario_trabajo);
                    this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'opera');
                }
                this.isSaving = false;
                this.$toast.add({severity:'success', summary: 'Agregado', detail: 'Trabajo Agregado', life: 2000});

            }catch(e){
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                this.isSaving = false;
                console.error(e);
            }
        },
        calcularPrecio(){
            //ARREGLAR PARA DECIMALES
            var trabajosEncontrados = this.trabajosTotales.filter(t => t.desc_linea == this.trabajoServiceSeleccionado.desc_linea && t.nombre_categoria == this.trabajoServiceSeleccionado.nombre_categoria && t.tipo_linea == this.trabajoServiceSeleccionado.tipo_linea);
            console.log('trabajosEncontrados', trabajosEncontrados);
            if(trabajosEncontrados[0].tipo_linea=="Materiales"){
                this.trabajoAEnviar = trabajosEncontrados[0];
            }else if(trabajosEncontrados[0].tipo_linea=="Desplazamiento"){
                this.trabajoAEnviar = trabajosEncontrados[0];
                var unidadesAFacturar = this.unidades - this.minKmFacturables;
                console.log('unidadesAFacturar', unidadesAFacturar);
                if(unidadesAFacturar>0){
                    var pr = this.trabajoAEnviar.precio * unidadesAFacturar;            
                    this.precio = Number(pr.toFixed(2));
                }
                console.log('precio', this.precio);
            }else{
                if(trabajosEncontrados.length==1){                     
                    var pr2 = this.unidades*trabajosEncontrados[0].precio;
                    this.precio = Number(pr2.toFixed(2));
                    this.trabajoAEnviar = trabajosEncontrados[0];
                }else{
                    var trabajoValido = [];
                    var max = 0;
                    var trabajoMenorMax = '';
                    var menorMax = 0;
                    var trabajoMayorMax = '';
                    var trabajoExtra = '';
                    trabajosEncontrados.forEach(t => {
                        t.precio = parseFloat(t.precio);
                        if(t.extra == '0'){
                            t.min_uds = parseFloat(t.min_uds);
                            t.max_uds = parseFloat(t.max_uds);
                            if(t.max_uds == ',5'){
                                t.max_uds = 0.5;
                            }
                            if(this.unidades>=t.min_uds && this.unidades<=t.max_uds){
                                trabajoValido.push(t);                            
                            }                        
                            if(trabajoMenorMax==''){
                                trabajoMenorMax = t;
                                trabajoMayorMax = t;
                                menorMax = t.max_uds;
                                max = t.max_uds;
                            }else{
                                if(t.max_uds<menorMax){
                                    trabajoMenorMax = t;
                                    menorMax = t.max_uds;
                                }else{
                                    trabajoMayorMax = t;
                                    max = t.max_uds;
                                }
                            }
                        }else{
                            trabajoExtra = t;
                        }
                    })
                    if(max>=this.unidades){
                        if(trabajoValido.length==1){
                            this.precio = trabajoValido[0].precio;
                            this.trabajoAEnviar = trabajoValido[0];
                        }else{
                            this.trabajoAEnviar = trabajoMenorMax;
                            this.precio = trabajoMenorMax.precio;
                        }
                    }else{
                        this.trabajoAEnviar = trabajoMayorMax;
                        var extras = this.unidades-max;
                        var precioExtra = extras*trabajoExtra.precio;
                        var pr3 = trabajoMayorMax.precio+precioExtra;
                        this.precio = Number(pr3.toFixed(2));
                    }
                }
            }
        },
        calcularPrecioTemporal(){
            var trabajosEncontrados = this.trabajosTotalesTemporales.filter(t => t.desc_linea == this.trabajoServiceTemporalSeleccionado.desc_linea && t.nombre_categoria == this.trabajoServiceTemporalSeleccionado.nombre_categoria && t.tipo_linea == this.trabajoServiceTemporalSeleccionado.tipo_linea);
            console.log('trabajosEncontradosTemp', trabajosEncontrados);
            if(trabajosEncontrados[0].tipo_linea=="Materiales"){
                this.trabajoAEnviarTemporal = trabajosEncontrados[0];
            }else if(trabajosEncontrados[0].tipo_linea=="Desplazamiento"){
                this.trabajoAEnviarTemporal = trabajosEncontrados[0];
                var unidadesAFacturar = this.unidadesTemporal - this.minKmFacturables;
                console.log('unidadesAFacturar', unidadesAFacturar);
                if(unidadesAFacturar>0){
                    var pr = this.trabajoAEnviarTemporal.precio * unidadesAFacturar;                    
                    this.precioTemporal = Number(pr.toFixed(2));
                }
                console.log('precio', this.precio);
            }
            else{
                if(trabajosEncontrados.length==1){ 
                    console.log('entra1');   
                    var pr2 = this.unidadesTemporal*trabajosEncontrados[0].precio;
                    console.log('encontrado', pr2, typeof pr2);
                    this.precioTemporal = Number(pr2.toFixed(2));
                    this.trabajoAEnviarTemporal = trabajosEncontrados[0];
                    console.log('precio', this.precioTemporal, typeof this.precioTemporal);
                }else{
                    console.log('entra2');
                    console.log('trenc', trabajosEncontrados);
                    var trabajoValido = [];
                    var max = 0;
                    var trabajoMenorMax = '';
                    var menorMax = 0;
                    var trabajoMayorMax = '';
                    var trabajoExtra = '';
                    trabajosEncontrados.forEach(t => {
                        t.precio = parseInt(t.precio);
                        if(t.extra == '0'){
                            t.min_uds = parseInt(t.min_uds);
                            t.max_uds = parseInt(t.max_uds);
                            if(t.max_uds == ',5'){
                                t.max_uds = 0.5;
                            }
                            if(this.unidadesTemporal>=t.min_uds && this.unidades<=t.max_uds){
                                trabajoValido.push(t);                            
                            }                        
                            if(trabajoMenorMax==''){
                                trabajoMenorMax = t;
                                trabajoMayorMax = t;
                                menorMax = t.max_uds;
                                max = t.max_uds;
                            }else{
                                if(t.max_uds<menorMax){
                                    trabajoMenorMax = t;
                                    menorMax = t.max_uds;
                                }else{
                                    trabajoMayorMax = t;
                                    max = t.max_uds;
                                }
                            }
                        }else{
                            trabajoExtra = t;
                        }
                    })
                    if(max>=this.unidadesTemporal){
                        if(trabajoValido.length==1){
                            this.precioTemporal = trabajoValido[0].precio;
                            this.trabajoAEnviarTemporal = trabajoValido[0];
                        }else{
                            this.trabajoAEnviarTemporal = trabajoMenorMax;
                            this.precioTemporal = trabajoMenorMax.precio;
                        }
                    }else{
                        this.trabajoAEnviarTemporal = trabajoMayorMax;
                        var extras = this.unidadesTemporal-max;
                        var precioExtra = extras*trabajoExtra.precio;
                        var pr3 = trabajoMayorMax.precio+precioExtra;
                        this.precioTemporal = Number(pr3.toFixed(2));
                    }
                }
            }
        },
        async obtenerAfectados(){
            this.afectadosCargados = false;
            this.oficiosCargados = false;
            var proce = 'P';            
            const api = new PwgsApi();
            try{
                this.isLoading = true;
                var datos = await api.post('servicios/' + this.trabajodatos.id + '/oficios', {procedencia: proce});
                if(datos.Error && datos.Error.CodError != '' && datos.Error.CodError != 0){
                    this.errorBaremo = datos.Error.DescError;
                    this.isLoading = false;
                    return;
                }else{
                    this.errorBaremo = '';
                }
                var trabajos = await api.get('trabajos/'+ this.trabajodatos.id + '/presuval-axa');
                if(!trabajos) trabajos = [];
                var creados = trabajos.filter(trabajo => trabajo.Enviado == 'S');
                if(datos.RepairEstimateValuationList){
                    console.log('entradatosencargo', datos);
                    this.afectadosPresupuestos = datos.RepairEstimateValuationList.Presupuestos.OficiosAfectado[0].Afectado;
                    this.afectadosValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado;
                    this.especialidadesPresupuestos = datos.RepairEstimateValuationList.Presupuestos.OficiosAfectado[0].Afectado[0].Especialidades;
                    this.especialidadesValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado[0].Especialidades;
                    this.cargarPresupuestosCreados(creados);
                }
                if(datos.DatosReparador){
                    this.facturaKm = datos.DatosReparador.FacturaKm;
                    this.minKmFacturables = datos.DatosReparador.MinKmFacturables;
                    console.log('entradatosrepara', this.minKmFacturables, datos.DatosReparador.MinKmFacturables);
                    this.incrementoImportePorUrgencia = datos.DatosReparador.IncrementoImportePorUrgencia;
                }
                this.afectados = datos.RepairEstimateValuationList['Presupuestos'].OficiosAfectado[0].Afectado;
                this.isLoading = false;
                this.afectadoSeleccionado = this.afectados[0];
                this.afectadosCargados = true;
                this.obtenerOficios();
            }catch(e){
                console.log('error', e);
                this.isLoading = false;
            }
        },
        async obtenerOficios(){
            this.oficios = this.afectadoSeleccionado.Especialidades;
            console.log('llgaobteneroficios', this.oficios);
            this.oficiosCargados = true;
        },  
        async obtenerOficiosTemporales(){
            this.oficiosEnPresupuestoActual = [];
            this.presupuestoTemporalSeleccionado.especialidades.forEach(especialidad => {
                this.oficiosEnPresupuestoActual.push(especialidad.idEspecialidad+'-'+especialidad.indice);
            })
            var aseguradoEncontrado = this.afectadosPresupuestos.find(afectado => afectado.IdAfectado == this.presupuestoTemporalSeleccionado.idAfectado);
            console.log('aseguradoencontrado', aseguradoEncontrado);
            this.oficiosTemporales = aseguradoEncontrado.Especialidades;
            this.oficiosTemporalesCargados = true;
        },
        async comprobarCompania(){
            if(this.servicio.compania.sistema){
                console.log('valores', this.trabajodatos);
                const api = new PwgsApi();
                this.especialidadesServicio = await api.get('servicios/' + this.trabajodatos.id + '/especialidades');
            }
        },
        comprobarOficioTemporal(){
            this.presupuestarTemporalCargado = false;
            this.presupuestarTemporalSeleccionado = '';
            setTimeout(() => {
                this.presupuestarTemporalTipos = [];
                console.log('llegaate');
                if(this.oficioTemporalSeleccionado.AdmitePresupuestarMO=='S'){
                    console.log('llegaaentrat');
                    this.presupuestarTemporalTipos.push('PresupuestarPorMO');                
                }
                if(this.oficioTemporalSeleccionado.AdmitePresupuestarBA=='S'){
                    this.presupuestarTemporalTipos.push('PresupuestarPorBaremo');
                    this.presupuestarTemporalSeleccionado = 'PresupuestarPorBaremo';
                }else{
                    this.presupuestarTemporalSeleccionado = 'PresupuestarPorMO';
                }
                
                if(this.oficioTemporalSeleccionado.AdmiteIVAReducido=='S'){
                    this.admiteIVAReducidoTemporal = true;
                }else{
                    this.admiteIVAReducidoTemporal = false;
                }
                console.log('oficioselec',this.oficioTemporalSeleccionado);
                this.ivasTemporal = this.oficioTemporalSeleccionado.IVAS[0].IVA;
                this.ivaSeleccionadoTemporal = this.ivasTemporal[0];
                
                this.presupuestarTemporalCargado = true;
            })  
        },
        comprobarOficio(){
            this.presupuestarCargado = false;
            this.presupuestarSeleccionado = '';
            setTimeout(() => {
                this.presupuestarTipos = [];
                console.log('llegaa');
            
                if(this.oficioSeleccionado.AdmitePresupuestarMO=='S'){
                    console.log('llegaaentra');
                    this.presupuestarTipos.push('PresupuestarPorMO');                
                }
                if(this.oficioSeleccionado.AdmitePresupuestarBA=='S'){
                    this.presupuestarTipos.push('PresupuestarPorBaremo');
                    this.presupuestarSeleccionado = 'PresupuestarPorBaremo';
                }else{
                    this.presupuestarSeleccionado = 'PresupuestarPorMO';
                }
            
                if(this.oficioSeleccionado.AdmiteIVAReducido=='S'){
                    this.admiteIVAReducido = true;
                }else{
                    this.admiteIVAReducido = false;
                }
                console.log('oficioselec',this.oficioSeleccionado);
                this.ivas = this.oficioSeleccionado.IVAS[0].IVA;
                this.ivaSeleccionado = this.ivas[0];
                this.presupuestarCargado = true;
            }, 100);            
        },       
        datosBaremo(valor){
            if(valor === this.trabajoServiceSeleccionado){
                return;
            }
            this.trabajoServiceSeleccionado = valor;
            console.log('trabajo', this.trabajoServiceSeleccionado);
            this.unidad = this.trabajoServiceSeleccionado.desc_unidad.toLowerCase();
            this.unidades = '';
            this.precio = '';
            this.comentario = '';
            if(this.trabajoServiceSeleccionado.tipo_linea == 'MO'){
                this.unidadesDisabled = false;
                this.urgenteVisible=true;
                this.precioDisabled = true;
                this.comentarioDisabled = true;
                this.minKmFacturablesVisible = false;
            }else if(this.trabajoServiceSeleccionado.tipo_linea == 'Desplazamiento'){
                this.unidadesDisabled = false;
                this.minKmFacturablesVisible = true;
                this.precioDisabled = true;
                this.comentarioDisabled = true;
                this.urgenteVisible=false;
            }else if(this.trabajoServiceSeleccionado.tipo_linea == "Baremo"){
                this.unidadesDisabled = false;
                this.precioDisabled = true;
                this.comentarioDisabled = true;
                this.urgenteVisible=false;
                this.minKmFacturablesVisible = false;
            } else{
                this.unidadesDisabled = false;
                this.precioDisabled = false;
                this.comentarioDisabled = false;
                this.urgenteVisible=false;
                this.minKmFacturablesVisible = false;
            }

        },
        datosBaremoTemporal(valor){
            if(valor === this.trabajoServiceTemporalSeleccionado){
                return;
            }
            this.trabajoServiceTemporalSeleccionado = valor;
            console.log('trabajo', this.trabajoServiceTemporalSeleccionado);
            this.unidadTemporal = this.trabajoServiceTemporalSeleccionado.desc_unidad.toLowerCase();
            this.unidadesTemporal = '';
            this.precioTemporal = '';
            this.comentarioTemporal = '';

            if(this.trabajoServiceTemporalSeleccionado.tipo_linea == 'MO'){
                this.unidadesDisabledTemporal = false;
                this.urgenteTemporalVisible=true;
                this.precioDisabledTemporal = true;
                this.comentarioDisabledTemporal = true;
                this.minKmFacturablesTemporalVisible = false;
            }else if(this.trabajoServiceTemporalSeleccionado.tipo_linea == 'Desplazamiento'){
                this.unidadesDisabledTemporal = false;
                this.minKmFacturablesTemporalVisible = true;
                this.precioDisabledTemporal = true;
                this.comentarioDisabledTemporal = true;
                this.urgenteTemporalVisible=false;
            }else if(this.trabajoServiceTemporalSeleccionado.tipo_linea == "Baremo"){
                this.unidadesDisabledTemporal = false;
                this.precioDisabledTemporal = true;
                this.comentarioDisabledTemporal = true;
                this.urgenteTemporalVisible=false;
                this.minKmFacturablesTemporalVisible = false;
            }else{
                this.unidadesDisabledTemporal = false;
                this.precioDisabledTemporal = false;
                this.comentarioDisabledTemporal = false;
                this.urgenteTemporalVisible=false;
                this.minKmFacturablesTemporalVisible = false;
            }
            

        },
        async cargarTrabajos(){
            const api = new PwgsApi;
            this.isLoading = true; // Iniciar el indicador de carga
            try {
                this.trabajos = await api.get('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/baremo');
            } catch (error) {
                alert('Error al cargar los trabajos');            
            }
            this.isLoading = false; // Finalizar el indicador de carga
        },
        async guardar(){
            const api = new PwgsApi;
            this.isSaving = true;  
            try{
                let payload;

                if(this.tarifaElbaSeleccionada){
                    payload = {
                        baremos_trabajos_elba: 1,
                        codigo: this.tarifaElbaSeleccionada.valor,
                        nombre: this.tarifaElbaSeleccionada.texto,
                        datos: this.tarifaElbaSeleccionada.parametros
                    }
                }else{
                    payload = { baremos_trabajos_id_trabajo: this.trabajoSeleccionado.idtrabajo }
                }

                await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', payload);
                this.$emit('update:visible', false)
                console.log('trabajodatosasas', this.trabajodatos, this.operario);
                if(this.trabajodatos.destinatario_trabajo == "" || this.trabajodatos.destinatario_trabajo == "Compañia"){
                    console.log('trabajodatosasas1');
                    this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'cliente');
                }else{
                    console.log('trabajodatosasas2', this.trabajodatos.destinatario_trabajo);
                    this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'opera');
                }
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
            } finally {
                this.isSaving = false;  // Detener el indicador de guardado
            }
        },
        async comprobarFacturacionAxa(){
            if(this.servicio && this.servicio.compania.sistema=='AXA_WS'){
                const api = new PwgsApi();
                var facturacionAxa = await api.get('parametros-pwgs/axa_facturacion');
                if(facturacionAxa.axa_facturacion == 1){
                    this.mostrarFacturacionAxa = true;
                }
            }
        },
        async cargarBaremosElba(){
            const api = new PwgsApi();
            const [tarifas, categorias] = await Promise.all([
                api.post('servicios/' + this.trabajodatos.id + '/datos-elba', { tipo: 'tarifas' }),
                api.post('servicios/' + this.trabajodatos.id + '/datos-elba', { tipo: 'categorias' }),
            ]);
            this.tarifasElba = Object.values(tarifas || {});
            this.categoriasElba = Object.values(categorias || {});
        }
    },
    watch: {
        presupuestoTemporalSeleccionado(){
            this.obtenerOficiosTemporales();
        },
        // trabajoServiceSeleccionado(){
        //     this.datosBaremo();
        // },
        // trabajoServiceTemporalSeleccionado(){
        //     this.datosBaremoTemporal();
        // },
        presupuestarSeleccionado(newVal){
            if(newVal!=''){
                this.obtenerBaremos();
            }
        },
        presupuestarTemporalSeleccionado(newVal){
            if(newVal!=''){
                this.obtenerBaremosTemporal();
            }
        },
        afectadoSeleccionado(){
            this.obtenerOficios();
        },
        oficioTemporalSeleccionado(){
            this.trabajosServiceTemporal = [];
            console.log('asas', this.oficioTemporalSeleccionado, this.oficiosEnPresupuestoActual);
            if(this.oficioTemporalSeleccionado==''){
                this.presupuestarTemporalCargado = false;
                this.presupuestarTemporalSeleccionado = '';
            }else{
                this.comprobarOficioTemporal();
            }
        },
        oficioSeleccionado(){
            this.trabajosService = [];
            if(this.oficioSeleccionado==''){
                this.presupuestarCargado = false;
                this.presupuestarSeleccionado = '';
            }else{
                this.comprobarOficio();
            }
        },
        visible(newVal) {
            //this.localVisible = newVal;
            if (newVal) {
                // Cargar los trabajos cuando el modal se haga visible
                this.cargarTrabajos();
            }
        },
        trabajoSeleccionado(){
            this.guardar();
        },
        tarifaElbaSeleccionada(){
            this.guardar();
        }
    },
    mounted() {        
        this.cargarCreados();
        this.comprobarFacturacionAxa();
    }
};
</script>

<style scoped>
.loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    color: #333;
    margin-top: 20px;
}
</style>